import { SelectGroup } from "@/components/ui/select";

export function PrtCustomerSelect({
  currentExport,
  data,
  setData,
  dataOptions,
}) {
  if (currentExport == "prt reporting") {
    return (
      <SelectGroup
        label="Customer"
        menuPosition="fixed"
        isClearable
        placeholder="Select Customer"
        className="w-full"
        options={dataOptions.customers ? dataOptions.customers : []}
        value={
          dataOptions.customers &&
          dataOptions.customers.find(
            (option) => option.value === data.customer_id,
          )
        }
        onChange={(e) => {
          setData({
            ...data,
            export_type: null,
            customer_id: e ? e.value : null,
          });
        }}
      />
    );
  }
  return null;
}
